import Swiper from 'swiper/bundle'
import 'swiper/css'
import 'swiper/css/effect-fade'

export default class VideoLibraryService {
    constructor() {
        VideoLibraryService.slider()
    }

    static slider() {
        const $element = $('[data-element="video-library-slider"]')

        $element.each(function () {
            const videoSlider = new Swiper(this, {
                mousewheel: {
                    forceToAxis: true,
                },
                speed: 600,
                effect: 'fade',
                fadeEffect: {
                    crossFade: true,
                },
                lazy: true,
                slidesPerView: 1,
                pagination: {
                    el: '.iris-video-slider-pagination',
                    bulletClass: 'iris-video-slider-pagination-bullet',
                    clickableClass: 'iris-video-slider-pagination-clickable',
                    currentClass: 'iris-video-slider-pagination-current',
                    bulletActiveClass: 'iris-video-slider-pagination-bullet-active',
                    type: 'bullets',
                    clickable: true,
                },
            })

            videoSlider.on('slideChange', () => {
                videoSlider.slides.each((slide) => {
                    VideoLibraryService.pauseMedia(slide)
                })
            })
        })
    }

    static pauseMedia(mediaParent) {
        const mediaVideo = $(mediaParent).find('video')
        const mediaIframe = $(mediaParent).find('iframe')

        // Video mp4
        if (mediaVideo.length > 0) {
            mediaVideo[0].pause()
        }

        // Video iframe
        if (mediaIframe.length > 0) {
            if (mediaIframe[0].src.startsWith('https://www.youtube.com')) {
                mediaIframe[0].contentWindow.postMessage(
                    '{"event":"command","func":"pauseVideo","args":""}',
                    '*',
                )
            }

            if (mediaIframe[0].src.startsWith('https://player.vimeo.com')) {
                mediaIframe[0].contentWindow.postMessage('{"method":"pause"}', '*')
            }

            if (mediaIframe[0].src.startsWith('https://www.dailymotion.com')) {
                mediaIframe[0].contentWindow.postMessage('{"command":"pause","parameters":[]}', '*')
            }
        }
    }
}
